import styled from '@emotion/styled'
import { CvsAutoComplete } from '@components'
import { DataType } from './data-types'
import { t } from '@lingui/core/macro'

const Container = styled.div`
  width: 160px;
  margin-top: -25px;
`
interface DataTypeSelectionProps {
  dataTypeOptions: DataType[]
  selected: string
  onChange: (selected: DataType | undefined) => void
}

export const DataTypeSelection = ({
  dataTypeOptions,
  selected,
  onChange,
}: DataTypeSelectionProps) => {
  return (
    <Container>
      <CvsAutoComplete
        options={dataTypeOptions as never[]}
        label={t`Data type`}
        selected={selected}
        onSelected={e => {
          const selectedDataType = dataTypeOptions.find(i => i.value === e)
          onChange(selectedDataType)
        }}
        error={!selected ? 'Please select a data type' : ''}
      />
    </Container>
  )
}
